/**
 * done
 */
import React, { useMemo } from 'react';
import { wrapReactionHook } from "../../hooks";
import { Upload } from "../Upload";
export var Images = wrapReactionHook(function (props) {
  var value = props.value;
  var renderValue = useMemo(function () {
    return Array.isArray(value) ? value.slice(0, 1) : [];
  }, [value]);
  return /*#__PURE__*/React.createElement(Upload, {
    mode: "picture",
    readOnly: true,
    value: renderValue
  });
});